import { RestAPI } from "../API/RestAPI";
import axios from "axios";
import { ConstructionsResponse } from "./types";
import { TireRackProductI } from "../store";

interface BaseResponse {
    status: "ok" | "fail";
}
export type PartialStoreState = DeepPartial<Record<keyof any, any>>; //TODO с разобраться что тут происходит
interface LoadProjectResponse extends BaseResponse {
    project?: PartialStoreState;
    userId?: number;
}
interface SaveProjectResponse extends BaseResponse {
    hash: string;
    userId: number;
}

export const Configurator = {
    async getFillings() {
        return await RestAPI.post("", {
            method: "conf_getFillings",
        });
    },
    async getModules() {
        return await RestAPI.post("", {
            method: "conf_getModules",
        });
    },

    async getConstructions() {
        return await RestAPI.post<ConstructionsResponse>("", {
            method: "conf_getConstructions",
        });
    },

    async addToBasket(basketItemsFormData: FormData) {
        return axios({
            method: "post",
            url: "/conf/ajax/add_to_basket.php",
            data: basketItemsFormData,
            headers: { "Content-Type": "multipart/form-data" },
        });
    },

    async loadProject(hash: string) {
        return await RestAPI.post<LoadProjectResponse>("", {
            method: "conf_loadProject",
            hash,
        });
    },

    async saveProject(project: PartialStoreState, hash?: string, isNewProject?: boolean) {
        let data: any = { project };
        if (hash) {
            data = { project, hash };
        }
        //Перезапись проекта вручную
        if (isNewProject) {
            data.isNewProject = isNewProject;
        }
        return await RestAPI.post<SaveProjectResponse>("", {
            method: "conf_saveProject",
            ...data,
        });
    },

    async getNomenclatureNamesByOfferIds(offerIds: string[]) {
        return await RestAPI.post("", {
            method: "conf_getNomenclatureNamesByOfferIds",
            offerIds,
        });
    },

    async getTireRacksFromProducts(offerIds: string[]) {
        return await RestAPI.post<TireRackProductI[]>("", {
            method: "conf_getTireRacksFromProducts",
            offerIds,
        });
    },
};
